function AltNull() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Alternative text is null or empty (alt="").</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>If an image does not convey content or if the content of the image is conveyed elsewhere (such as in a caption or nearby text), the image should have empty/null alternative text (alt="") to ensure that it is ignored by a screen reader and is hidden when images are disabled or unavailable.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that the image does not convey content or that the content of the image is conveyed in nearby text (e.g., a caption).</p>
    </blockquote>
  )
}

export default AltNull